import { Tabs } from "antd"
import { useState } from "react"
import CashPaymentForm from "./CashPaymentForm"
import CardPaymentForm from "./CardPaymentForm"
import PropTypes from "prop-types"
import CustomDrawer from "ui/Drawer"
import { useBreakpoints } from "modules/window/hooks/useBreakpoints"
import { Modal } from "ui/Modal"
import styles from "../RecordPayment/index.module.css"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { isPaypalConnectedSelector, isStripeConnectedSelector } from "store/user"
import { isFeatureEnabled } from "config/features"
const AdjustBookingPriceModal = ({ onOpen, onClose, currentPrice, bookingUUID, bookingId }) => {
  const [activeTab, setActiveTab] = useState("cash")
  const breakpoint = useBreakpoints()
  const isMobile = ["xs", "xsm", "sm", "md"].includes(breakpoint)
  const { t } = useTranslation()
  const isStripeConnected = useSelector(isStripeConnectedSelector)
  const isPaypalConnected = useSelector(isPaypalConnectedSelector)
  const paypalFeatureEnabled = isFeatureEnabled("PAYPAL_SUPPORT")
  let cardLabel = null;
  if (isStripeConnected && isPaypalConnected && paypalFeatureEnabled) {
    cardLabel = "Card/Paypal";
  } else if (isStripeConnected) {
    cardLabel = "Card";
  } else if (isPaypalConnected && paypalFeatureEnabled) {
    cardLabel = "Paypal";
  }

  const tabItems = [
    {
      key: "cash",
      label: "Cash",
      children: <CashPaymentForm currentPrice={currentPrice} bookingUUID={bookingUUID} bookingId={bookingId} onClose={onClose} />
    }
  ]
  if (cardLabel) {
    tabItems.push({
      key: "card",
      label: cardLabel,
      children: <CardPaymentForm onClose={onClose} bookingId={bookingId} bookingUUID={bookingUUID} currentPrice={currentPrice} />
    })
  }

  const modalContent = <Tabs className={styles.recordPaymentTabs} activeKey={activeTab} onChange={setActiveTab} items={tabItems} centered />

  return isMobile ? (
    <CustomDrawer open={onOpen} setOpen={onClose} title={t("client.client_booking.adjust_booking_price")}>
      {modalContent}
    </CustomDrawer>
  ) : (
    <Modal centered title={t("client.client_booking.adjust_booking_price")} open={onOpen} onCancel={onClose} width={800}>
      {modalContent}
    </Modal>
  )
}

AdjustBookingPriceModal.propTypes = {
  onOpen: PropTypes.bool,
  onClose: PropTypes.func,
  currentPrice: PropTypes.number,
  bookingUUID: PropTypes.string,
  bookingId: PropTypes.number
}

export default AdjustBookingPriceModal
